import { Button, Checkbox, FormControlLabel, ListItem, Stack, TextField } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import { generateQrCode } from '../../contexts/AwsCognitoContext';
import Card from '@mui/material/Card';
import { RootState, useSelector } from '../../redux/store';
import { useEffect, useState } from 'react';
import { updateMfaConfiguration } from '../../redux/slices/user';

const Security = () => {
  const [qrCode, setQrCode] = React.useState('');
  const [qrCodeValidation, setQrCodeValidation] = React.useState('');
  const { t } = useTranslation();
  const { setupTOTP, user, verifyTOTP } = useAuth();
  const { user: applicatioUser } = useSelector((state: RootState) => state.user);

  const [mfaEnabled, setMfaEmabled] = useState(false);

  useEffect(() => {
    if (applicatioUser) {
      setMfaEmabled(applicatioUser.attributes.mfa_enabled);
    }
  }, [applicatioUser]);
  return (
    <Stack>
      <ListItem>
        <FormControlLabel
          control={
            <Checkbox
              checked={mfaEnabled}
              onClick={(event: any) => {
                if (event.target.checked) {
                  setupTOTP().then((code) => {
                    generateQrCode(code, user?.email, 'Giraf.io').then((image) => {
                      console.log(image);
                      setQrCode(image);
                    });
                  });
                } else {
                  updateMfaConfiguration(false);
                }
              }}
            />
          }
          label={t('Use two-factor authentication')}
        />
      </ListItem>
      {qrCode ? (
        <Stack>
          <Card component="img" src={qrCode} alt="QR Code" width={'300px'} />
          <TextField
            fullWidth
            type="text"
            value={qrCodeValidation}
            label={t('MFA validation ').toString()}
            onChange={(event) => setQrCodeValidation(event.target.value)}
          />
          <Button
            variant={'contained'}
            onClick={() => {
              verifyTOTP(qrCodeValidation);
            }}
          >
            {t('Validate MFA code')}
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default Security;
